import { render, staticRenderFns } from "./PsItem.vue?vue&type=template&id=8cd242ba&scoped=true&"
import script from "./PsItem.vue?vue&type=script&lang=js&"
export * from "./PsItem.vue?vue&type=script&lang=js&"
import style0 from "./PsItem.vue?vue&type=style&index=0&id=8cd242ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd242ba",
  null
  
)

export default component.exports